import {
    Component,
    Input,
    Output,
    EventEmitter,
    OnChanges,
    SimpleChanges,
    OnInit,
} from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-comp-cards',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './comp-cards.component.html',
    styleUrls: ['./comp-cards.component.scss'],
})
export class CompCardsComponent implements OnInit {
    @Input() image!: string;
    @Input() title!: string;
    @Input() gaPrefix!: string;
    @Input() subtitle!: string;
    @Input() description!: string;
    @Input() buttonText: string = 'Learn more';
    @Input() url!: string;
    @Output() buttonClick = new EventEmitter<void>();
    ga: any = {
        id: '',
        label: '',
        category: 'JC3 Button Click',
    };

    ngOnInit(): void {
        let slug = this.title?.toLowerCase()?.replaceAll(' ', '_');
        this.ga.id = this.gaPrefix + slug + '_button_jc3_click';
        this.ga.label = this.gaPrefix.replaceAll('_', ' ');
    }

    onButtonClick(): void {
        // Emit the event for parent component to handle
        this.buttonClick.emit();
    }
}
